import {i18n} from '@/plugins/i18n'

export const walletErrorStatus = {
    NOT_HANDLED: 0,
    HANDLED: 1,
};

export const walletErrorTypes = {
    SETTLEMENT: 0,
    CHARGE: 1,
};

export const walletErrorReasons = {
    OTHER: 0,
    INVALID_TOKEN: 1,
    MAX_USAGE_LIMIT: 2,
    INSUFFICIENT_BALANCE: 3,
    INVALID_DATA: 4,
    TIMEOUT: 5,
    PROVIDER_EXCEPTION: 6,
    THROTTLE: 7,
    THROTTLE_DAILY: 8,
    SERVICE_IS_OFF: 9,
};

export const walletErrorStatusStr = {
    NOT_HANDLED: i18n.t('label.wallet_errors_columns.not_handled'),
    HANDLED: i18n.t('label.wallet_errors_columns.handled'),

    get(status) {
        let status_str = null;

        Object.keys(walletErrorStatus).forEach(item => {
            if (walletErrorStatus[item] === status) {
                status_str = walletErrorStatusStr[item];
            }
        });

        return status_str;
    }
};

export const walletErrorTypesStr = {
    SETTLEMENT: i18n.t('label.wallet_errors_columns.settlement'),
    CHARGE: i18n.t('label.wallet_errors_columns.charge'),

    get(status) {
        let status_str = null;

        Object.keys(walletErrorTypes).forEach(item => {
            if (walletErrorTypes[item] === status) {
                status_str = walletErrorTypesStr[item];
            }
        });

        return status_str;
    }
};
export const walletErrorReasonsStr = {
    OTHER: i18n.t('label.wallet_errors_columns.other'),
    INVALID_TOKEN: i18n.t('label.wallet_errors_columns.invalid_token'),
    MAX_USAGE_LIMIT: i18n.t('label.wallet_errors_columns.max_usage_limit'),
    INSUFFICIENT_BALANCE: i18n.t('label.wallet_errors_columns.insufficient_balance'),
    INVALID_DATA: i18n.t('label.wallet_errors_columns.invalid_data'),
    TIMEOUT: i18n.t('label.wallet_errors_columns.timeout'),
    PROVIDER_EXCEPTION: i18n.t('label.wallet_errors_columns.provider_exception'),
    THROTTLE: i18n.t('label.wallet_errors_columns.throttle'),
    THROTTLE_DAILY: i18n.t('label.wallet_errors_columns.throttle_daily'),
    SERVICE_IS_OFF: i18n.t('label.wallet_errors_columns.service_is_off'),

    get(reason) {
        let reason_str = null;

        Object.keys(walletErrorReasons).forEach(item => {
            if (walletErrorReasons[item] === reason) {
                reason_str = walletErrorReasonsStr[item];
            }
        });

        return reason_str;
    }
};

export const walletErrorStatusVariant = (status) => {
    switch (status) {
        case walletErrorStatus.HANDLED:
            return 'primary';
        case walletErrorStatus.NOT_HANDLED:
            return 'danger';

    }

    return 'warning';
};

export const walletErrorTypesVariant = (status) => {
    switch (status) {
        case walletErrorTypes.SETTLEMENT:
            return 'primary';
        case walletErrorTypes.CHARGE:
            return 'danger';
    }
    return 'warning';
};
